import type { AihubLayoutConfig } from 'ecosystem'

/** `layout.aihub` with defaults applied: omitted/undefined = shown, only `false` hides. */
export const resolveAihubVisibility = (config?: AihubLayoutConfig) => {
  const showOnDesktop = config?.showOnDesktop !== false
  const showOnTablet = config?.showOnTablet !== false
  const showOnMobile = config?.showOnMobile !== false

  return {
    showOnDesktop,
    showOnTablet,
    showOnMobile,
    isVisibleAnywhere: showOnDesktop || showOnTablet || showOnMobile,
    /** Tablet and mobile both open the hub from the top-nav trigger. */
    isNavTriggerVisible: showOnTablet || showOnMobile
  }
}

export type AihubVisibility = ReturnType<typeof resolveAihubVisibility>
